export const REFUND_REASONS = [
	{
		value: 'SHIPMENT_CONTRACT',
		label: 'Shipment contract',
	},
	{
		value: 'SHIPMENT_ANNEX_TO_THE_CONTRACT',
		label: 'Shipment annex to the contract',
	},
	{
		value: 'SHIPMENT_HEADPHONES',
		label: 'Shipment headphones',
	},
	{
		value: 'SHIPMENT_TERMINATION_OF_THE_CONTRACT',
		label: 'Shipment termination of the contract',
	},
	{
		value: 'MEDICAL_CERTIFICATE',
		label: 'Medical certificate',
	},
	{
		value: 'OTHER',
		label: 'Other',
	},
];

export const REFUND_STATUSES = [
	{
		value: 'TO_DO',
		label: 'To do',
	},
	{
		value: 'DONE',
		label: 'Done',
	},
	{
		value: 'NOT_ACCEPTED',
		label: 'Not accepted',
	},
]